export const STATUS_INSTANCE = ['draft', 'pending', 'active', 'inactive', 'blocked', 'archived'];
export const STATUS_INSTANCE_BLOCKED = 'blocked';



// WEBPACK FOOTER //
// ./src/constants/status.js